import {Component, Input, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SpinnerService} from '../../shared/services/spinner.service';
import {ToastNotificationService} from '../../shared/services/toast-notify.service';
import {Authority} from '../../models/authority.model';
import {ParentService} from './services/parent.service';
import { environment } from 'src/environments/environment';
import { InventoryService } from '../inventory/services/inventory.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { FeeService } from '../fee/services/fee.service';
import { RazorpayService } from '../inventory/services/razorpay.service';
import { RazorpayDto } from 'src/app/models/razorpay.model';

@Component({
  selector: 'app-parent',
  templateUrl: './payamount.component.html',
  styleUrls: ['./parent.component.scss'],  
})
export class PayAmountComponent implements OnInit {

  //@Input() branchDetail: Branch;
  @Input() studentFeeId: number;
  @Input() balanceAmount: number;
  @Input() modalRef: NgbModalRef;
  payAmount: number = 0;

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private spinnerService: SpinnerService,
              private toastNotifyService: ToastNotificationService,
              private inventoryService: InventoryService, private parentService: ParentService,
              private tokenStorageService: TokenStorageService, private feeService: FeeService,private razorpayService: RazorpayService,
              ) {  }

  ngOnInit() {
    console.log("**inside PayAmountComponent..."); 
  }
  /** User confirmed student deletion. Delete user from DB and on success close dialog */
  confirm() {
    console.log('-------------pay amount:',this.payAmount);
    this.spinnerService.showSpinner();
    if(this.payAmount > this.balanceAmount || this.payAmount == 0){
      this.toastNotifyService.showErrorWithTimeout('Payment amount exceeds balance amount', "Notification", 7000);
      this.spinnerService.hideSpinner();
      return;
    }
    
    const razorpayDto: RazorpayDto ={"amount": this.payAmount,"currency":"INR"}
    this.razorpayService.createFeeOrder(razorpayDto).subscribe((razorOrder: any) => {
      console.log('>>>>>createFeeOrder razorpay response :', JSON.stringify(razorOrder.data));
      this.razorpayService.payFeeWithRazor(razorOrder.data, this.studentFeeId);

      this.spinnerService.hideSpinner();  
      this.modalRef.close();
      //this.toastNotifyService.showSuccess('Payment Successful', "Notification");
    },
      err => {
        console.log('!!! Error from razorpay cretaedOrder:',err);    
        this.toastNotifyService.showErrorWithTimeout('Error & Payment Failure', "Notification", 7000);
        this.spinnerService.hideSpinner();     
      },
    );
    this.spinnerService.hideSpinner(); 
  }
  /** Dismiss dialog */
  cancel() {
    console.log('****cancel-dismiss modal');
    this.modalRef.dismiss();
  }

  /** Close modal */
  close() {
    console.log('****close modal*****');
    this.modalRef.close();
  }
}
